/**************  CSS  **************/
import './TrainLength.css'

/**********  React hooks  **********/
import { useEffect, useRef, useState } from 'react'
import { useWakeLock } from 'react-screen-wake-lock'

/**********  Components  ***********/
import TrainLengthForm from './TrainLengthForm/TrainLengthForm'
import TrainLengthCalc from './TrainLengthCalc/TrainLengthCalc'
import TrainLengthConfirmation from './TrainLengthConfirmation/TrainLengthConfirmation'

/************  Others  *************/
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function TrainLength() {
    /***********************************/
    /* Hooks                           */
    /***********************************/
    const { isSupported: wlIsSupported, request: wlRequest, release: wlRelease } = useWakeLock({
        reacquireOnPageVisible: true,
    });
    /*************  Refs  **************/
    const storedTrainLength = useRef(Number(sessionStorage.getItem('trainLength')))
    const storedTrainSpeed = useRef(Number(sessionStorage.getItem('trainSpeed')))
    
    /************  States  *************/
    const [length, setLength] = useState(storedTrainLength.current ? storedTrainLength.current : 100);
    const [speed, setSpeed] = useState(storedTrainSpeed.current ? storedTrainSpeed.current : 40);
    const [formState, setFormState] = useState(0) //0: Form, 1: Calculate, 2: Length ok
    
    /************  Memos  **************/
    
    
    /***********  Callbacks  ***********/
    
    
    /************  Effects  ************/
    useEffect(() => {
        wlRequest();
        return () => {
            wlRelease()
        }
    }, [])
    useEffect(() => {
        sessionStorage.setItem('trainLength', length)
    }, [length])

    useEffect(() => {
        sessionStorage.setItem('trainSpeed', speed)
    }, [speed])

    const submitForm = e => {
        e.preventDefault()

        setFormState(1)
    }

    const backToForm = () => {
        setFormState(0)
    }

    const lengthOk = () => {
        setFormState(2)
    }

    return <div>
        <h1>Calcul longueur train</h1>
        {!wlIsSupported ? <center><FontAwesomeIcon icon="fa-solid fa-circle-info" /> Wake lock pas supporté</center> : false}
        {formState === 0 ? <TrainLengthForm length={length} setLength={setLength} speed={speed} setSpeed={setSpeed} submitForm={submitForm} /> : false}
        {formState === 1 ? <TrainLengthCalc length={length} speed={speed} backToForm={backToForm} lengthOk={lengthOk} /> : false}
        {formState === 2 ? <TrainLengthConfirmation backToForm={backToForm} length={length} speed={speed} /> : false}
    </div>
}